import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";
import { onMounted, watch } from "vue";
import { includes } from "./../core/keep-alive/keepAlive";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import NP from "number-precision/src/index";
import { FileRecord } from "@/core/services/file-upload.interface";
import { submitSuccessEmitter } from "@/utils/emitter";
import { HttpService } from "@/core";
import { useStore } from "@/store";
/**
 * 根据文件url获取文件名
 * @param url 文件url
 */
export const getFileName = (url) => {
  url = url || "";
  const num = url.lastIndexOf("/") + 1;
  let fileName = url.substring(num);
  fileName = decodeURI(fileName.split("?")[0]);
  return fileName;
};

export const urlToFileRecord = (url) => {
  url = url || "";
  const record = new FileRecord();
  record.merge({
    uuid: generateUuid(),
    url,
    name: getFileName(url),
    suffix: getFileExt(url),
  });
  return record;
};

export const urlsToFileRecords = (urls) => {
  return (urls || []).map((url) => urlToFileRecord(url));
};

/**
 * 根据文件地址下载文件
 * @param {*} sUrl
 */
export const downloadByUrl = ({
  url,
  target = "_blank",
  fileName,
}: {
  url: string;
  target?: "_self" | "_blank";
  fileName?: string;
}): Promise<boolean> => {
  // 是否同源
  const isSameHost = new URL(url).host == location.host;
  return new Promise<boolean>((resolve, reject) => {
    if (isSameHost) {
      const link = document.createElement("a");
      link.href = url;
      link.target = target;

      if (link.download !== undefined) {
        link.download = fileName || getFileName(url);
      }

      if (document.createEvent) {
        const e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        link.dispatchEvent(e);
        return resolve(true);
      }

      if (url.indexOf("?") === -1) {
        url += "?download";
      }

      window.open(url, target);
      return resolve(true);
    } else {
      const canvas = document.createElement("canvas");
      const img = document.createElement("img");
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = url;
      img.onload = (e) => {
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext("2d")!;
        context.drawImage(img, 0, 0, img.width, img.height);
        // window.navigator.msSaveBlob(canvas.msToBlob(),'image.jpg');
        // saveAs(imageDataUrl, '附件');
        canvas.toBlob((blob: any) => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = getFileName(url);
          link.click();
          URL.revokeObjectURL(link.href);
          resolve(true);
        }, "image/jpeg");
      };
      img.onerror = (e) => reject(e);
    }
  });
};

export const mergeAjaxDataToForm = (ajaxData, formRef) => {
  _.merge(formRef || {}, _.pick(ajaxData || {}, Object.keys(formRef)));
};

/**
 * Axios params 中如果包含数组类型的字段, 则转为逗号分隔
 */
export const compileAxiosParams = (params) => {
  const output = {};
  Object.keys(params || {}).forEach((key) => {
    const val = params[key];
    if (_.isArray(val)) {
      output[key] = val.join(",");
    } else {
      output[key] = val;
    }
  });
  return output;
};

export const attachChildren = (list, parentId, children) => {
  const recurse = (list, children) => {
    return (list || []).map((item) => {
      if (item.id === parentId) {
        item.children = children || [];
      } else {
        if (item.children) {
          item.children = recurse(item.children, children);
        }
      }
      return item;
    });
  };
  return recurse(list, children);
};

export const getFileExt = (fileName) => {
  return (fileName || "").split(".").pop();
};

export const generateUuid = (): string => {
  return uuidv4();
};

export const attachUuid = (array, pId?) => {
  array.forEach((item) => {
    if (!item.uuid) {
      item.uuid = generateUuid();
      pId && (item.parentId = pId);
    }
  });
  return array;
};

export const calcTotalPrice = (records, countField = "count", priceField = "price") => {
  let t = 0;
  (records || []).forEach((item) => {
    console.log(item[countField], countField, item[priceField], priceField);
    const recordPrice = NP.times(item[countField] || 0, item[priceField] || 0);
    // console.log(item, recordPrice);
    t = NP.plus(t, recordPrice);
  });
  return t;
};
export const plusTotalPrice = (records, totalPrice = "totalPrice") => {
  let t = 0;
  (records || []).forEach((item) => {
    const recordPrice = item[totalPrice] || 0;
    t = NP.plus(t, recordPrice);
  });
  return t;
};

export const getCurrentUserId = () =>
  IsZhiHuiXingHe()
    ? Cookies.get("cpms_tenant_user_id", { domain: ".metawit.cn" })
    : Cookies.get("cpms_tenant_user_id", { domain: ".partnerone.cn" });

export const getCurrentTenantId = () =>
  IsZhiHuiXingHe()
    ? Cookies.get("tid", { domain: ".metawit.cn" })
    : Cookies.get("tid", { domain: ".partnerone.cn" });

export const getCurrentCompanyId = () =>
  IsZhiHuiXingHe()
    ? Cookies.get("cid", { domain: ".metawit.cn" })
    : Cookies.get("cid", { domain: ".partnerone.cn" });
export const getCurrentMobile = () =>
  IsZhiHuiXingHe()
    ? Cookies.get("uMobile", { domain: ".metawit.cn" })
    : Cookies.get("uMobile", { domain: ".partnerone.cn" });

export const countTotalPrice = (list, fieldName) => {
  return (list || []).reduce((p, n) => {
    if (Number(n[fieldName]) > 0) {
      p += Number(n[fieldName]);
    }
    return p;
  }, 0);
};
export const countTotalPrices = (list, fieldName) => {
  return (list || []).reduce((p, n) => {
    if (isNaN(n[fieldName])) {
      n[fieldName] = 0;
    }
    p += Number(n[fieldName]);
    return p;
  }, 0);
};
export const onSuccess = (bizId, bizType) => {
  submitSuccessEmitter.emit("submit-success", {
    bizId,
    bizType,
  });
};
export const isNumber = (value) => {
  return typeof value === "number" && !isNaN(value);
};
//合并两个对象
export const merge = (to, from) => {
  let a1 = Object.keys(to);
  let a2 = Object.keys(from);
  a1.forEach((k) => {
    if (a2.includes(k)) {
      to[k] = from[k];
    }
  });
};
export const clearCookies = () => {
  Object.keys(Cookies.get()).forEach((key) => {
    Cookies.remove(key);
    Cookies.remove(key, { domain: ".partnerone.cn" });
    Cookies.remove(key, { domain: ".metawit.cn" });
  });
};
//获取左侧菜单消息通知，在页面红点展示
export const getNoticeList = async (store) => {
  const api = () =>
    HttpService.axios({
      method: "GET",
      url: "/examine_instance/dispose/menu",
    });
  const { data, run } = HttpService.useRequest<any>(api);
  await run();
  // console.log("noticeList", (data.value as any)?.notificationTemplate);
  store.commit("notice/SET_NOTICE_LIST", (data.value as any)?.notificationTemplate);
};
interface ILabelWidth {
  width?: number;
  include: Array<string>;
  timeout?: number;
}
const sleep = (time = 0) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(null);
    }, time);
  });
};
export const setDesLabelWidth = async (
  cls = "include-descriptions-label-width" as any,
  width = 110
) => {
  if (cls && typeof cls === "number") {
    width = cls;
    cls = "include-descriptions-label-width";
  } else if (cls && typeof cls === "string" && !width) {
    width = 110;
  } else if (cls && typeof cls === "string" && typeof width !== "number") {
    width = 110;
  } else if (cls && typeof cls === "string" && typeof width === "number") {
  } else {
    cls = "include-descriptions-label-width";
    width = 110;
  }
  await setDescriptionsLabelWidth({ width, include: [cls] });
};
//设置label宽度
export const setDescriptionsLabelWidth = async (params: ILabelWidth) => {
  let { include, width = 110, timeout } = params;
  await sleep(timeout);
  let p = document.getElementsByClassName("ant-descriptions-item-label");
  Array.from(p).forEach((y) => {
    (y as any).setAttribute(
      "style",
      `width: ${width}px;
        display: block;
        text-align: right;`
    );
  });
  // if (include && include.length > 0) {
  //   include.forEach((o) => {
  //     let t = document.getElementsByClassName(o);
  //     if (t && t.length > 0) {
  //       Array.from(t).forEach((m) => {
  //         let p = m.getElementsByClassName("ant-descriptions-item-label");
  //         Array.from(p).forEach((y) => {
  //           (y as any).setAttribute(
  //             "style",
  //             `width: ${width}px;
  //               display: block;
  //               text-align: right;`
  //           );
  //         });
  //       });
  //     }
  //   });
  // }
};
//input框动态显示与隐藏clear按钮
export const bindHoverEvent = (time = 20) => {
  setTimeout(() => {
    let tmp = document.getElementsByClassName("ant-input");
    if (tmp[0]) {
      Array.from(tmp).forEach((o: any) => {
        let parentNode = o.parentNode;
        let tt = parentNode.getElementsByClassName("ant-input-clear-icon")[0];
        if (tt) {
          (tt as any).style.opacity = 0;
        }
        parentNode.addEventListener(
          "mouseout",
          () => {
            let t = parentNode.getElementsByClassName("ant-input-clear-icon")[0];
            if (t) {
              (t as any).style.opacity = 0;
            }
          },
          false
        );
        parentNode.addEventListener(
          "mouseover",
          () => {
            let t = parentNode.getElementsByClassName("ant-input-clear-icon")[0];
            if (t) {
              (t as any).style.opacity = 1;
            }
          },
          false
        );
      });
    }
  }, time);
};

// 文件转换
export function getFileSize(size) {
  if (!size) return "";
  const num = 1024.0; //byte
  if (size < num) return size + "B";
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + "KB"; //kb
  if (size < Math.pow(num, 3)) return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
  if (size < Math.pow(num, 4)) return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
  return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}

export function exportFileByUrl(url) {
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// 对象数组根据多个属性去重
export function arrayUniqByMore(arr: Array<any>, props: Array<string>) {
  let obj = {};
  let reduce = arr.reduce((curr, next) => {
    let key = "";
    props.map((prop) => {
      key += next[prop] ? next[prop] : "";
    });

    /*判断对象中是否已经有该属性  没有的话 push 到 curr数组*/
    obj[key] ? "" : (obj[key] = curr.push(next));
    return curr;
  }, []);
  return reduce;
}
// 对象数组根据多个属性去重合并
export function arrayUniqByMoreMerge(
  arr: Array<any>,
  props: Array<string>,
  mergeProps: Array<string>
) {
  let obj = {};
  let tmp: string[] = [];
  let reduce = arr.reduce((curr, next) => {
    let key: string = "";
    props.map((prop) => {
      key += next[prop] ? next[prop] : "";
    });
    /*判断对象中是否已经有该属性  没有的话 push 到 curr数组*/

    obj[key] ? "" : (obj[key] = curr.push(next));
    if (tmp.indexOf(key) > -1) {
      mergeProps.forEach((keyVal) => {
        curr[tmp.indexOf(key)][keyVal] += next[keyVal];
      });
    } else {
      tmp.push(key);
    }
    return curr;
  }, []);
  return reduce;
}

export function random_string() {
  var s: any = [];
  var hexDigits = "0123456789abcdefghigklmnopkrstuvwsyz";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
}
